export const headingLogin = {
	title: "Đăng nhập",
	desc: "Đăng nhập để sử dụng Chatvia."
}

export const headingRegister = {
	title: "Đăng ký",
	desc: "Đăng ký tài khoản Chatvia ngay."
}